import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

import { NgSelectModule } from '@ng-select/ng-select';

import { CfssAgencyComponent } from './cfss-agency.component';
import { supportService } from '../supportplanner/supportplanner.service';
import { CFSSAgecnygrid } from './cfss-agency.service';
import { CFSSRoutingModule } from './cfss-agency-routing.module';


@NgModule({
  declarations: [
    CfssAgencyComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    CFSSRoutingModule,
    NgSelectModule,
    
  ],
   schemas:[NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA],
  providers: [CFSSAgecnygrid, supportService,ColumnChooserService,PageService,SortService,FilterService, ResizeService]
})
export class CFSSAgencyModule { }
